(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petsure-homepage"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const revealPetSure = () => {
      const elements = document.querySelectorAll('.ps-home .ps-reveal:not([data-ps-reveal])');
      if (!elements.length) return;

      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        elements.forEach((element) => element.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.14, rootMargin: '0px 0px -5% 0px' });

      elements.forEach((element) => {
        element.dataset.psReveal = 'true';
        observer.observe(element);
      });
    };

    const initialiseRoamTagSelector = () => {
      document.querySelectorAll('[data-roamtag-picker]:not([data-roamtag-ready])').forEach((picker) => {
        const select = picker.querySelector('[data-roamtag-select]');
        const card = picker.closest('.rt-buy-card');
        const image = card?.querySelector('[data-roamtag-image]');
        const variantInput = card?.querySelector('[data-roamtag-variant-id]');
        if (!select || !image || !variantInput) return;
        picker.dataset.roamtagReady = 'true';

        const updateColour = () => {
          const option = select.options[select.selectedIndex];
          const colour = option.dataset.colour || 'blue';
          variantInput.value = option.value;
          image.dataset.colour = colour;
          if (option.dataset.image) image.src = option.dataset.image;
          image.alt = `${option.text} PetSure RoamTag GPS tracker and collar`;
          const swatches = { blue:'#2f6f9f', pink:'#ef9db8', black:'#202020' };
          picker.style.setProperty('--rt-swatch', swatches[colour] || '#2f6f9f');
        };

        select.addEventListener('change', updateColour);
        updateColour();
      });
    };

    const initialiseRoamTagQuantity = () => {
      document.querySelectorAll('[data-roamtag-quantity-picker]:not([data-roamtag-quantity-ready])').forEach((picker) => {
        const card = picker.closest('.rt-buy-card');
        const input = card?.querySelector('[data-roamtag-quantity-input]');
        const buttonCopy = card?.querySelector('[data-roamtag-button-copy]');
        const buttonPrice = card?.querySelector('[data-roamtag-button-price]');
        const choices = picker.querySelectorAll('[data-roamtag-quantity]');
        if (!input || !choices.length) return;
        picker.dataset.roamtagQuantityReady = 'true';
        choices.forEach((choice) => choice.addEventListener('click', () => {
          choices.forEach((item) => item.classList.toggle('is-selected', item === choice));
          input.value = choice.dataset.roamtagQuantity || '1';
          if (buttonCopy) buttonCopy.textContent = input.value === '2' ? 'Add 2 to cart' : 'Add to cart';
          if (buttonPrice) buttonPrice.textContent = choice.dataset.roamtagPrice || '';
        }));
      });
    };

    revealPetSure();
    initialiseRoamTagSelector();
    initialiseRoamTagQuantity();
    document.addEventListener('shopify:section:load', () => {
      revealPetSure();
      initialiseRoamTagSelector();
      initialiseRoamTagQuantity();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petsure-legal-footer"] && !Shopify.designMode) return;
  try {
    
  (()=>{const roots=document.querySelectorAll('[data-ps-legal-footer]');roots.forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const close=dialog=>{if(dialog?.open)dialog.close()};root.querySelectorAll('[data-ps-policy-open]').forEach(button=>button.addEventListener('click',()=>{const dialog=root.querySelector(`#PsPolicy-${button.dataset.psPolicyOpen}`);if(dialog?.showModal)dialog.showModal()}));root.querySelectorAll('[data-ps-policy-close]').forEach(button=>button.addEventListener('click',()=>close(button.closest('dialog'))));root.querySelectorAll('.ps-policy-dialog').forEach(dialog=>dialog.addEventListener('click',event=>{if(event.target===dialog)close(dialog)}));root.querySelectorAll('[data-ps-cookie-settings]').forEach(button=>button.addEventListener('click',()=>{const privacy=window.Shopify?.customerPrivacy;if(privacy?.showPreferences){close(button.closest('dialog'));privacy.showPreferences()}}))})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petsure-product-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = () => document.querySelectorAll('[data-pp-root]:not([data-pp-ready])').forEach((root) => {
      root.dataset.ppReady = 'true';
      const revealSteps = [...root.querySelectorAll('.pp--tracker .pp-feature-showcase, .pp--tracker .pp-feature-card, .pp--tracker .pp-steps article')];
      if (revealSteps.length && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        root.classList.add('pp-reveal-ready');
        const revealObserver = new IntersectionObserver((entries) => entries.forEach((entry) => {
          if (entry.isIntersecting) { entry.target.classList.add('is-visible'); revealObserver.unobserve(entry.target); }
        }), { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
        revealSteps.forEach((step, index) => { step.style.setProperty('--reveal-delay', (index * 80) + 'ms'); revealObserver.observe(step); });
      }
      const main = root.querySelector('[data-pp-main-image]');
      const thumbs = [...root.querySelectorAll('[data-pp-thumb]')];
      let galleryIndex = 0;
      const showImage = (index) => {
        if (!thumbs.length || !main) return;
        galleryIndex = (index + thumbs.length) % thumbs.length;
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = thumbs[galleryIndex].dataset.image;
        thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === galleryIndex));
        thumbs[galleryIndex].scrollIntoView({ behavior:'smooth', block:'nearest', inline:'center' });
      };
      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showImage(index)));
      root.querySelector('[data-pp-gallery-prev]')?.addEventListener('click', () => showImage(galleryIndex - 1));
      root.querySelector('[data-pp-gallery-next]')?.addEventListener('click', () => showImage(galleryIndex + 1));
      const gallery = root.querySelector('.pp-gallery__main');
      let touchStart = 0;
      gallery?.addEventListener('touchstart', (event) => { touchStart = event.touches[0].clientX; }, { passive:true });
      gallery?.addEventListener('touchend', (event) => {
        const distance = event.changedTouches[0].clientX - touchStart;
        if (Math.abs(distance) > 45) showImage(galleryIndex + (distance < 0 ? 1 : -1));
      }, { passive:true });

      const variantSelect = root.querySelector('[data-pp-variants]');
      const idInput = root.querySelector('[data-pp-variant-id]');
      const price = root.querySelector('[data-pp-price]');
      const buttonPrice = root.querySelector('[data-pp-button-price]');
      const submit = root.querySelector('[data-pp-submit]');
      const buyNow = root.querySelector('[data-pp-buy-now]');
      const stock = root.querySelector('[data-pp-stock]');
      const update = () => {
        if (!variantSelect) return;
        const chosen = [...root.querySelectorAll('[data-pp-option]')].map((group) => {
          const selected = group.querySelector('[data-pp-option-value].is-selected');
          const select = group.querySelector('[data-pp-option-select]');
          return selected?.dataset.ppOptionValue || select?.value || '';
        });
        const option = [...variantSelect.options].find((item) => item.dataset.options.split('||').every((value,index) => value === chosen[index]));
        if (!option) return;
        variantSelect.value = option.value;
        if (idInput) idInput.value = option.value;
        if (price) price.textContent = option.dataset.price;
        const was = root.querySelector('[data-pp-was]');
        const saving = root.querySelector('[data-pp-saving]');
        const onSale = Number(option.dataset.compare) > Number(option.dataset.cents);
        if (was && saving) { was.hidden = saving.hidden = !onSale; was.textContent = option.dataset.was; saving.textContent = 'Save ' + option.dataset.saving; }
        root.querySelectorAll('[data-pp-quantity]').forEach(choice => {
          const pair = choice.dataset.ppQuantity === '2';
          choice.dataset.ppOfferPrice = pair ? option.dataset.pairPrice : option.dataset.price;
          const amount = choice.querySelector('b');
          if (amount) { const badge = amount.querySelector('em'); amount.textContent = choice.dataset.ppOfferPrice; if (badge) amount.prepend(badge); }
        });
        const activeQuantity = root.querySelector('[data-pp-quantity].is-selected');
        if (buttonPrice) buttonPrice.textContent = activeQuantity?.dataset.ppOfferPrice || option.dataset.price;
        const available = option.dataset.available === 'true';
        if (submit) { submit.disabled = !available; submit.querySelector('span').textContent = available ? (activeQuantity?.dataset.ppQuantity === '2' ? 'Add 2 to cart' : 'Add to cart') : 'Sold out'; }
        if (buyNow) buyNow.disabled = !available;
        if (stock) { const low = available && Number(option.dataset.lowStock) > 0; stock.classList.toggle('pp-stock--low', low); stock.querySelector('span').textContent = !available ? 'Currently unavailable' : low ? 'Low stock' : 'Available to order — ready for your next adventure'; }
        if (main && option.dataset.image) { main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = option.dataset.image; }
      };
      root.querySelectorAll('[data-pp-option-value]').forEach((button) => button.addEventListener('click', () => {
        const group = button.closest('[data-pp-option]');
        group.querySelectorAll('[data-pp-option-value]').forEach((item) => { item.classList.toggle('is-selected', item === button); item.setAttribute('aria-pressed', item === button ? 'true' : 'false'); });
        const label = group.querySelector('[data-pp-option-label]');
        if (label) label.textContent = button.dataset.ppOptionValue;
        if (main && button.dataset.ppColourImage) { main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = button.dataset.ppColourImage; }
        update();
        if (main && button.dataset.ppColourImage) { main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = button.dataset.ppColourImage; }
      }));
      root.querySelectorAll('[data-pp-option-select]').forEach((select) => select.addEventListener('change', update));
      const quantityInput = root.querySelector('[data-pp-quantity-input]');
      const quantityChoices = root.querySelectorAll('[data-pp-quantity]');
      quantityChoices.forEach((choice) => choice.addEventListener('click', () => {
        quantityChoices.forEach((item) => item.classList.toggle('is-selected', item === choice));
        if (quantityInput) quantityInput.value = choice.dataset.ppQuantity;
        if (buttonPrice) buttonPrice.textContent = choice.dataset.ppOfferPrice;
        if (submit && !submit.disabled) submit.querySelector('span').textContent = choice.dataset.ppQuantity === '2' ? 'Add 2 to cart' : 'Add to cart';
      }));
      if (buyNow) buyNow.addEventListener('click', async () => {
        if (!idInput?.value || buyNow.disabled) return;
        const quantity = Number(quantityInput?.value || 1);
        buyNow.disabled = true;
        buyNow.textContent = 'Taking you to checkout…';
        try {
          const response = await fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body:JSON.stringify({ id:Number(idInput.value), quantity }) });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign('/checkout');
        } catch (error) {
          buyNow.disabled = false;
          buyNow.textContent = 'Buy now — checkout securely';
          if (submit) submit.click();
        }
      });
      update();
    });
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
